export default "__VITE_ASSET__D8aNgb6J__"